import { useAppDispatch, useAppSelector } from "../store";
import { setSnackBar } from "../store/slices/snackbarSlice";

export const useSnackbar = () => {
  const dispatch = useAppDispatch();

  const snackbar: any = useAppSelector((state) => state.snackbarSlice.snackbar);

  const showError = (message: string, stayOpen = false) => {
    dispatch(setSnackBar({ open: true, severity: "error", message, stayOpen }));
  };
  const showSuccess = (message: string, id = "", stayOpen = false) => {
    dispatch(
      setSnackBar({ open: true, severity: "success", message, stayOpen, id })
    );
  };

  const handleError = (errorData: any, error404 = true) => {
    if (!error404) {
      return;
    }
    if (errorData?.status == "FETCH_ERROR") {
      showError(`Request access denied`);
      return;
    }
    showError(`${errorData?.data?.context?.details}`);
  };

  const hideSnackbar = () => {
    dispatch(
      setSnackBar({
        open: false,
        message: "",
        severity: "info",
        stayOpen: false,
      })
    );
  };

  const autoHideSnackbar = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(
      setSnackBar({ ...snackbar, open: false, message: "", stayOpen: false })
    );
  };

  return {
    showError,
    showSuccess,
    hideSnackbar,
    autoHideSnackbar,
    handleError,
  };
};
